var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18472)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5071 28.4667H34.0265L35.2682 35.6594C35.4504 36.7143 35.8339 37.7243 36.3978 38.6343C36.4667 38.7454 36.3868 38.889 36.256 38.889H19.1949C19.1018 38.889 19.046 38.7855 19.0972 38.7077C19.7272 37.7509 20.1494 36.6726 20.3364 35.5424L21.5071 28.4667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.822 31.5778C18.822 30.2032 19.9363 29.0889 21.3109 29.0889H34.5331C35.9077 29.0889 37.022 30.2032 37.022 31.5778C37.022 32.9523 35.9077 34.0666 34.5331 34.0666H21.3109C19.9363 34.0666 18.822 32.9523 18.822 31.5778Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5331 29.5555H21.3109C20.1941 29.5555 19.2887 30.4609 19.2887 31.5778C19.2887 32.6946 20.1941 33.6 21.3109 33.6H34.5331C35.65 33.6 36.5554 32.6946 36.5554 31.5778C36.5554 30.4609 35.65 29.5555 34.5331 29.5555ZM21.3109 29.0889C19.9363 29.0889 18.822 30.2032 18.822 31.5778C18.822 32.9523 19.9363 34.0666 21.3109 34.0666H34.5331C35.9077 34.0666 37.022 32.9523 37.022 31.5778C37.022 30.2032 35.9077 29.0889 34.5331 29.0889H21.3109Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2731 63.4002C8.66827 54.3161 13.9208 44.8403 23.0049 42.2355C32.089 39.6307 41.5648 44.8832 44.1696 53.9673L44.727 55.9112C47.3318 64.9953 42.0793 74.4711 32.9952 77.0759C23.9111 79.6807 14.4353 74.4282 11.8305 65.3441L11.2731 63.4002Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2784 56.0398L43.721 54.0959C41.1872 45.2596 31.9699 40.1503 23.1335 42.6841C14.2972 45.2179 9.1879 54.4352 11.7217 63.2716L12.2791 65.2155C14.8129 74.0518 24.0302 79.1611 32.8666 76.6273C41.703 74.0935 46.8122 64.8762 44.2784 56.0398ZM23.0049 42.2355C13.9208 44.8403 8.66827 54.3161 11.2731 63.4002L11.8305 65.3441C14.4353 74.4282 23.9111 79.6807 32.9952 77.0759C42.0793 74.4711 47.3318 64.9953 44.727 55.9112L44.1696 53.9673C41.5648 44.8832 32.089 39.6307 23.0049 42.2355Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7111 37.6445H32.6666V42.6222H22.7111V37.6445Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1999 38.1111H23.1777V42.1556H32.1999V38.1111ZM22.7111 37.6445V42.6222H32.6666V37.6445H22.7111Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1781 37.6445H32.2003V43.8667H23.1781V37.6445Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5334 24.6556C20.5334 20.5748 23.8416 17.2667 27.9223 17.2667C32.0031 17.2667 35.3112 20.5748 35.3112 24.6556V32.9C35.3112 36.9808 32.0031 40.2889 27.9223 40.2889C23.8416 40.2889 20.5334 36.9808 20.5334 32.9V24.6556Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8446 32.9V24.6556C34.8446 20.8325 31.7454 17.7333 27.9223 17.7333C24.0993 17.7333 21.0001 20.8325 21.0001 24.6556V32.9C21.0001 36.723 24.0993 39.8222 27.9223 39.8222C31.7454 39.8222 34.8446 36.723 34.8446 32.9ZM27.9223 17.2667C23.8416 17.2667 20.5334 20.5748 20.5334 24.6556V32.9C20.5334 36.9808 23.8416 40.2889 27.9223 40.2889C32.0031 40.2889 35.3112 36.9808 35.3112 32.9V24.6556C35.3112 20.5748 32.0031 17.2667 27.9223 17.2667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 26.2889H22.2444L21 29.2444V26.2889Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8445 26.2889H33.6L34.8445 29.2444V26.2889Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2235 43.7111C35.9175 46.1322 32.3179 48.0431 27.9223 48.0431C23.5523 48.0431 19.9689 46.1543 19.6268 43.7531C13.7732 45.4296 9.48901 50.8213 9.48901 57.2136V67.7914H46.5112V57.2136C46.5112 50.7669 42.1538 45.3378 36.2235 43.7111Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8233 47.1983C32.2583 48.0193 30.1827 48.5098 27.9223 48.5098C25.675 48.5098 23.6105 48.0249 22.0487 47.2126C20.6981 46.51 19.6612 45.5257 19.2856 44.3456C13.8688 46.1138 9.95568 51.2073 9.95568 57.2136V67.3247H46.0446V57.2136C46.0446 51.1551 42.0631 46.0254 36.5732 44.3003C36.2125 45.4925 35.1772 46.4881 33.8233 47.1983ZM36.1253 44.1681C35.4548 46.3684 32.0373 48.0431 27.9223 48.0431C23.8326 48.0431 20.4318 46.3888 19.732 44.2085C19.6841 44.059 19.6488 43.9072 19.6268 43.7531C19.4755 43.7965 19.3251 43.8423 19.1759 43.8906C13.5544 45.7092 9.48901 50.9866 9.48901 57.2136V67.7914H46.5112V57.2136C46.5112 50.9321 42.3743 45.6168 36.6762 43.8436C36.5264 43.797 36.3755 43.7528 36.2235 43.7111C36.204 43.8657 36.171 44.0181 36.1253 44.1681Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8088 22.6614C19.8088 20.7226 21.0076 18.9857 22.8204 18.2981L23.5866 18.0075C26.4301 16.9289 29.5701 16.9289 32.4135 18.0075L33.1797 18.2981C34.9925 18.9857 36.1913 20.7226 36.1913 22.6614V27.0667H19.8088V22.6614Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7246 26.6001V22.6614C35.7246 20.9164 34.6457 19.3533 33.0142 18.7344L32.248 18.4438C29.5112 17.4057 26.4889 17.4057 23.7521 18.4438L22.986 18.7344C21.3544 19.3533 20.2755 20.9164 20.2755 22.6614V26.6001H35.7246ZM22.8204 18.2981C21.0076 18.9857 19.8088 20.7226 19.8088 22.6614V27.0667H36.1913V22.6614C36.1913 20.7226 34.9925 18.9857 33.1797 18.2981L32.4135 18.0075C29.5701 16.9289 26.4301 16.9289 23.5866 18.0075L22.8204 18.2981Z",
    fill: "#111111"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric04);
export default __webpack_public_path__ + "static/media/Generic 04.e2db9a6527f56c003b9337aea7924cd8.svg";
export { ForwardRef as ReactComponent };